import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  px: 0,
  minWidth: '30px',
  position: 'relative',
  '&.Mui-disabled': {
    pointerEvents: 'auto',
  },
};
